// DS: i3.25
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const AddToGroupFill: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M9.74 14.606a1 1 0 01.92-.606h2.68a1 1 0 01.92.606l2.143 5a1 1 0 01-.92 1.394H8.517a1 1 0 01-.92-1.394l2.143-5zM18.923 13a1 1 0 01.928.629l1.6 4A1 1 0 0120.523 19h-2.21l-.035-.091-2.194-5.121.06-.146c.259-.19.503-.398.733-.62a.912.912 0 01.2-.022h1.846zm-12 0a1 1 0 01.202.02c.171.168.351.326.539.474l.191.145.06.149-2.156 5.03-.07.182H3.477a1 1 0 01-.928-1.371l1.6-4A1 1 0 015.077 13h1.846zM12 3c1.844 0 3.454.998 4.321 2.483l.128.232c.072.141.138.286.198.435l.102.282.063.205.053.202.044.207.046.278.02.167.016.21.003.048a5.08 5.08 0 010 .503L17 8c0 .095-.003.19-.008.284l-.022.263-.058.391-.066.297-.063.227-.047.145c-.052.153-.11.303-.177.448l-.126.26-.142.253-.124.197-.145.205A5.002 5.002 0 017.34 9.816l-.094-.263-.07-.232-.06-.243-.06-.325-.032-.265-.018-.235-.004-.126L7 8c0-.085.002-.17.006-.254L7 8c0-.117.004-.233.012-.348l.024-.258.02-.139c.02-.14.047-.28.08-.416l.052-.202.082-.262.09-.24.1-.234.045-.093.066-.13A4.999 4.999 0 0112 3zm6.5 2a3.5 3.5 0 11-.707 6.929A6.957 6.957 0 0019 8a6.973 6.973 0 00-.672-2.996L18.5 5zm-13 0l.172.004A6.973 6.973 0 005 8c0 1.456.445 2.809 1.206 3.928A3.5 3.5 0 115.5 5z"
      />
    </svg>
  </IconWrap>
);
AddToGroupFill.displayName = 'AddToGroupFill';

export default AddToGroupFill;
